import React from "react";

import Hero from "components/Hero";

export default function SCM() {
	window.scrollTo(0, 0);
	document.title = "SCM || Jozini Municipality";

	return (
			<Hero
				subheading="SCM"
				title="SCM"
				description="Minima dolorum vero quas ullam exercitationem animi. Soluta dicta excepturi temporibus assumenda."
				backgroundImage={require("images/page-title.jpg")}
				hideAppointmentButton
			/>
	);
}
